import _ from 'lodash';
import enUS from './en-US.json';
import jaJP from './ja-JP.json';

export const enCoffee = _.reduce(enUS, (result, value, key) => ({ ...result, [key]: `☕️ ${value} ☕️` }), {});

export const messages = { 'en-us': enUS, 'ja-jp': jaJP, 'en-coffee': enCoffee };

export const messagesFor = (target) => _.get(messages, _.toLower(target), enUS);